(function($) {
    $( document ).on( 'gform_confirmation_loaded', function( event, formId ) {
        const htmlFormId = 'gf_' + formId;
        let $form = $('#' + htmlFormId);

        // Skip if not found.
        if ($form.length === 0) {
            return;
        } 

       let $newsletterWrapper = $form.parents( '.newsletter-group' );
       let $newsletterKnowledgeBaseWrapper = $form.parents( '.panel.newsletter' );
       let $footerWrapper = $form.parents( '.site-footer' );
       let $newsletterPageFormWrapper = $form.parents( '.form-group' );

        // It's the Newsletter form.
        if ( $newsletterWrapper.length > 0 ) {
            $newsletterWrapper.find( '.intro-text' ).addClass( 'confirmation-loaded' );
        }

        // It's the Newsletter form in knowledge base articles.
        if ( $newsletterKnowledgeBaseWrapper.length > 0 ) {
            $newsletterKnowledgeBaseWrapper.find( 'h4' ).addClass( 'confirmation-loaded' );
        }

        // It's the footer form.
        if ( $footerWrapper.length > 0 ) {
            $footerWrapper.find( '.intro-text' ).addClass( 'confirmation-loaded' );
        }

        // It's the Newsletter form on Newsletter page.
        if ( $newsletterPageFormWrapper.length > 0 ) {
            $newsletterPageFormWrapper.addClass( 'confirmation-loaded' );
        }

        if ( $( window ).width() > 767 ) {
            setScrollPosition( document.getElementById( 'gform_confirmation_wrapper_' + formId ) );
        }
    });

    $( document ).on( 'gform_post_render', function( event, formId ) {
        addPrefixNumber();

        const formWrapper = document.getElementById( 'gform_wrapper_' + formId );
        if ( formWrapper && formWrapper.classList.contains('gform_validation_error') && $( window ).width() > 767 ) {
            setScrollPosition( document.getElementById( 'gform_wrapper_' + formId ) );
        }
    } );

})(jQuery);


/**
 * Add class to phone field to display prefix number
 */
const addPrefixNumber = () => {

    const phoneField = document.querySelector( '.gravity-contact-form_wrapper .ginput_container_phone' );

    if ( ! phoneField ) {
        return;
    }

    const input = phoneField.querySelector( 'input' );

    if ( input.value !== '' ) {
        phoneField.classList.add( 'ginput_container_phone--focused' );
    }

    input.addEventListener( 'focus', () => {
        phoneField.classList.add( 'ginput_container_phone--focused' );
    })

    input.addEventListener( 'focusout', () => {

        if ( input.value === '' ) {
            phoneField.classList.remove( 'ginput_container_phone--focused' );
        }
    })
}


/**
 * Scroll to the form, so that it appears below sticky menu
 * 
 * @param {HTMLElement} formWrapper Queryselector for form wrapper
 */
const setScrollPosition = (formWrapper) => {
    const header = document.querySelector( '#masthead' );

    if ( ! formWrapper || ! header ) {
        return;
    }

    const sectionElement = formWrapper.closest( 'section' );
    const sectionTop = sectionElement.getBoundingClientRect().top;
    const formTop = formWrapper.getBoundingClientRect().top;
    const margin = formTop - sectionTop;

    const headerHeight = header.offsetHeight + 40;
    const offset = margin + headerHeight;
    const formPosition = formTop + window.scrollY - offset;

    setTimeout( function() {
        window.scrollTo({
            top: formPosition,
            behavior: 'smooth'
        });
    }, 50 ); // Delay to ensure it runs after Gravity Forms scripts

}

